export const useCreateDistributionCardDefaultValues = () => ({
  title_ru: '',
  content_ru: '',
  title_kz: '',
  content_kz: '',
  title_kg: '',
  content_kg: '',
  title_uz: '',
  content_uz: '',
  notification_type: '',
  app_types: [],
  action_button: {
    label: '',
    url: '',
  },
  file: null,
  sales_points_file: '',
  sales_points_file_name: '',
  image_guid: '',
  b2b_directions: [],
  b2b_tiers: [],
  source_ids: [],
  user_ids: [],
  city_ids: [],
  country_ids: [],
});
